import { render, staticRenderFns } from "./baseTreeSelect.vue?vue&type=template&id=6db338c2&"
import script from "./baseTreeSelect.vue?vue&type=script&lang=ts&"
export * from "./baseTreeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports